export const environment = {
    host: '',
    basePath: '/api/v1/',
    production: true,
    lazyTimeMs: 0
};
